export var AccountingPeriodStatus;
(function (AccountingPeriodStatus) {
    AccountingPeriodStatus["Pending"] = "Pending";
    AccountingPeriodStatus["Approved"] = "Approved";
})(AccountingPeriodStatus || (AccountingPeriodStatus = {}));
export var PeriodReviewStatus;
(function (PeriodReviewStatus) {
    PeriodReviewStatus["Overdue"] = "Overdue";
    PeriodReviewStatus["Pending"] = "Pending";
    PeriodReviewStatus["Approved"] = "Approved";
})(PeriodReviewStatus || (PeriodReviewStatus = {}));
export const CHECKLIST_ITEM_KEYS = [
    'bankTransactionsReconciliation',
    'bankBalancesStatement',
    'incomeExpensesInvestmentsAndRealisations',
    'transactionRates',
    'accrualsPayablesReceivables',
    'prepaymentResolutions',
    'companyValuations',
    'unrealisedFxGainsAndLosses',
    'awaitingCommitments',
    'transactionsPendingCall',
];
//# sourceMappingURL=index.js.map